export class CreateCollaboratorBatch {
    public itens: CreateCollaborator[];
    public file: string;
    public typeCollaborator: number;

    constructor(itens: CreateCollaborator[], file: string, typeCollaborator: number) {
        this.itens = itens;
        this.file = file;
        this.typeCollaborator = typeCollaborator;
    }
}

export class CreateCollaborator {
    
    public endereco: CollaboratorAddress;

    constructor(
        public email: string,
        public nome: string,
        public sobrenome: string,
        public documento: string,
        public dataNascimento: Date,
        public sexo: string,
        public matricula: string,
        public nomeMae: string,
        public nomePai: string,
        public celular: string,
        public centroCustoCod: string,
        public unidadeCod: string,
        public departamentoCod: string,
        ) { }
    }

export class CollaboratorAddress {
    public cep: string;
    public address: string;
    public number: string;
    public complement: string;
    public neighborhood: string;
    public city: string;
    public uf: string;
}

export class StatusBatch {

    constructor(erro: number, processada: number, total: number) {
        this.erro = erro;
        this.processada = processada;
        this.total = total;
    }
    
    public erro: number;
    public processada: number;
    public total: number;
}
